import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { fontWeight } from '@savgroup-front-common/primitive/helpers/fontWeight';
import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $QuotationTitle = styled.div`
  padding: ${spacing('lg')};

  & > div > * {
    margin-right: ${spacing('xs')};
  }

  @media ${media.maxWidth.sm} {
    padding: 0;
  }
`;

export const $LightSpan = styled.span`
  font-weight: ${fontWeight('light')};
`;
